import './ObjectHoverTooltip.scss';

import { AccessObject } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SonarText } from '@ui/text';

import React, { useMemo } from 'react';
import { Space, Tooltip } from 'antd';

interface ObjectHoverTooltipProps {
    accessObject: AccessObject;
    children: React.ReactElement;
	open: boolean;
}

export const ObjectHoverTooltip: React.FC<ObjectHoverTooltipProps> = ({
	children,
	accessObject,
	open
}) => {
	const tooltipContent = useMemo(() => {

		if (!accessObject.userAccessNames?.length) {
			return (
				<SonarText className='object-hover-tooltip__empty'>
					{ COPY_SPECIFIC.NO_ACCESS_NAME }
				</SonarText>
			);
		}

		return (
			<Space
				className='object-hover-tooltip__content'
				direction='vertical'
				size='small'>
				<Space
					className='object-hover-tooltip__access-item'
					direction='vertical'
					key={ accessObject.name }
					size='small'>
					<Space
						className='object-hover-tooltip__access-tags'
						role='list'
						size='small'
						wrap>
						{ accessObject.userAccessNames.map((name) =>
							<SonarText
								className='object-hover-tooltip__access-tag'
								key={ name }
								role='listitem'
								size={ 12 }>
								{ name }
							</SonarText>) }
					</Space>
				</Space>
			</Space>
		);
	}, [ accessObject ]);

	return (
		<div className='object-hover-tooltip-container'>
			<Tooltip
				open={ open ? undefined : false }
				placement='bottom'
				title={ tooltipContent }
				trigger='hover'>
				<Space
					className='object-hover-tooltip__wrapper'>
					{ children }
				</Space>
			</Tooltip>
		</div>
	);
};
